import { call, put, takeEvery, select } from "redux-saga/effects";

// Login Redux States
import {
  GET_USER_SETTINGS,
  PATCH_USER_SETTINGS,
  USER_GET_PERMISSIONS,
  USER_GET_PROFILE,
  USER_INIT,
  USER_PATCH_PROFILE,
  USER_TOKEN_REFRESH,
} from "./actionTypes";

// import { loginSuccess, logoutUserSuccess } from "./actions";
//Include Both Helper File with needed methods

import {
  getPermissions,
  getUserProfile,
  getUserSettings,
  patchUserProfile,
  patchUserSettings,
  postTokenRefresh,
} from "../../helpers/jwt_helper";
import authHeader from "../../helpers/jwt-token-access/auth-token-header";
import { updateAuthorizationToken } from "../../helpers/api_helper";
import {
  hideUserSettingsLoader,
  setErrorUserProfile,
  setUserSettings,
  showUserSettingsLoader,
  userSetIsLogin,
  userSetPermissions,
  userSetProfile,
} from "./actions";
import {
  showErrorMessage,
  showSuccessMessage,
  getErrorMessage,
} from "../../helpers/utils";
import { getUsersToList } from "./user-list/actions";

function* userTokenRefresh({ payload: history }) {
  try {
    const refresh = authHeader();
    if (!refresh) throw null;
    const response = yield call(postTokenRefresh, { refresh });

    updateAuthorizationToken(response.access);

    yield put(userSetIsLogin(true));

    return true;
  } catch (error) {
    localStorage.removeItem("authUser");
    updateAuthorizationToken("");
    yield put(userSetIsLogin(false));
    // history.push("/login");
    return false;
  }
}

function* userInit(payload) {
  const isLogin = yield call(userTokenRefresh, payload);

  if (isLogin) {
    yield onGetUserSettings();
    yield userGetPermissionsWorker();
  }
}

function* userGetPermissionsWorker() {
  try {
    let response = yield call(getPermissions);

    // response.permissions = ['view_campaignmodel', 'view_clientmodel']
    const data = {};
    response.permissions.forEach(i => {
      data[i] = i;
    });
    // console.log(data);
    yield put(userSetPermissions(data));
  } catch (error) {}
}

function* onUserGetProfile({ payload: id }) {
  try {
    let response = yield call(getUserProfile, id);
    yield put(userSetProfile(response));
  } catch (error) {
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorUserProfile(true));
    }
  }
}

function* onUserPatchProfile({ payload: { id, data, type } }) {
  try {
    yield put(showUserSettingsLoader());
    let response = yield call(patchUserProfile, id, data);
    if (type == 'update_from_table') {
      let tableData = yield select(state => state.UsersList.data);
      yield put(getUsersToList(tableData))
    } else {
      yield put(userSetProfile(response));
    }
    showSuccessMessage(`Updating user ${data.username} has been successfully`);
    yield put(hideUserSettingsLoader());
  } catch (error) {
    yield put(hideUserSettingsLoader());
    showErrorMessage(getErrorMessage(error));
    if (getErrorMessage(error) === "Not found.") {
      yield put(setErrorUserProfile(true));
    }
  }
}

function* onGetUserSettings() {
  try {
    yield put(showUserSettingsLoader());
    let response = yield call(getUserSettings);
    yield put(setUserSettings(response));
    yield put(hideUserSettingsLoader());
  } catch (error) {
    console.error(error);
    yield put(hideUserSettingsLoader());
    // showErrorMessage(getErrorMessage(error));
  }
}

function* onPatchUserSettings({ payload }) {
  try {
    yield put(showUserSettingsLoader());
    let response = yield call(patchUserSettings, payload);
    yield put(setUserSettings(response));
    yield put(hideUserSettingsLoader());
  } catch (error) {
    console.error(error);
    yield put(hideUserSettingsLoader());
  }
}

function* userSaga() {
  yield takeEvery(USER_INIT, userInit);
  yield takeEvery(USER_TOKEN_REFRESH, userTokenRefresh);
  yield takeEvery(USER_GET_PERMISSIONS, userGetPermissionsWorker);
  yield takeEvery(USER_GET_PROFILE, onUserGetProfile);
  yield takeEvery(USER_PATCH_PROFILE, onUserPatchProfile);
  yield takeEvery(GET_USER_SETTINGS, onGetUserSettings);
  yield takeEvery(PATCH_USER_SETTINGS, onPatchUserSettings);
}

export default userSaga;
